/* LargAroma card ATC - global functions called via onclick */
function laFmt(c){return '\u20B9'+(c/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2});}

function laFb(uid,msg,cls){
  var el=document.getElementById('lafb_'+uid);
  if(!el)return;
  el.textContent=msg;
  el.className='la-card-fb '+(cls||'');
  if(cls==='ok')setTimeout(function(){el.textContent='';el.className='la-card-fb';},2500);
}

function laVarChange(sel){
  var uid=sel.id.replace('lavar_','');
  var opt=sel.options[sel.selectedIndex];
  if(!opt)return;
  var price=parseInt(opt.dataset.price||0,10);
  var compare=parseInt(opt.dataset.compare||0,10);
  var avail=opt.dataset.avail==='true';
  var vid=opt.value;
  var pe=document.getElementById('lapr_'+uid);
  if(pe)pe.innerHTML=compare>price
    ?'<span class="la-card-price-sale">'+laFmt(price)+'</span><span class="la-card-price-compare">M.R.P.: '+laFmt(compare)+'</span>'
    :'<span class="la-card-price-regular">'+laFmt(price)+'</span>';
  var btn=document.getElementById('laatc_'+uid);
  if(btn){btn.dataset.vid=vid;btn.disabled=!avail;btn.textContent=avail?'ADD TO CART':'SOLD OUT';btn.classList.remove('la-added','la-adding');}
  laFb(uid,'','');
}

function laAtcClick(btn){
  if(btn.disabled||btn.classList.contains('la-adding'))return;
  var uid=btn.dataset.uid;
  var vid=parseInt(btn.dataset.vid,10);
  var qel=document.getElementById('laqty_'+uid);
  var qty=qel?parseInt(qel.value,10):1;
  if(!vid){laFb(uid,'Please select a variant.','err');return;}
  btn.classList.add('la-adding');
  btn.textContent='Adding...';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:vid,quantity:qty})
  })
  .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d};});})
  .then(function(res){
    btn.classList.remove('la-adding');
    if(!res.ok||(res.d.status&&res.d.status>=400))throw new Error(res.d.description||res.d.message||'Error');
    btn.classList.add('la-added');
    btn.textContent='\u2713 Added!';
    laFb(uid,qty+' item'+(qty>1?'s':'')+' added','ok');
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(c){
        document.querySelectorAll('.cart-count-bubble span').forEach(function(el){el.textContent=c.item_count;});
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        if(window.publish)window.publish('cart:update',{cart:c});
      }).catch(function(){});
    setTimeout(function(){btn.classList.remove('la-added');btn.textContent='ADD TO CART';},2500);
  })
  .catch(function(err){
    btn.classList.remove('la-adding');
    btn.textContent='ADD TO CART';
    laFb(uid,err.message||'Could not add. Try again.','err');
  });
}
